import {formatNumber} from "@ui-seeker/utils";

export const priceEvolutionWidgetFormatPrice = (value, currency) => {
	if (!value) return 'N/A'
	return `${formatNumber(value)} ${currency}`
}